// Germany
export const locale = {
  OVERVIEW: {
    PAGETITLE: "Dokumente Übersicht",
    Description:
      "Verwalten, filtern und erstellen Sie Rechnungen, Gutschriften und Stornobelege.",
    DASHBOARD: "Hauptseite",
    Button_NewInvoice: "Rechnung",
    Button_CreditNote: "Gutschrift",
    Type: "Art",
    Number: "Nummer",
    Date: "Datum",
    Client: "Kunde",
    Status: "Status",
    Paid: "Zahlung",
    Creater: "Ersteller",
    Options: "Optionen",
    LoadingMessage: "Loading documents... Please wait",
    AUTO_GENERATED: "Generiert",
    DRAFT: "ENTWURF",
    SEND: "GESENDET",
    SAVED: "GESPEICHERT",
  },
  MENU: {
    DASHBOARD: "Hauptseite",
    Administration: "Administration",
    Documents: "Dokumente",
    Clients: "Kunden",
    "Items/Article": "Artikel"
  },
  CREATE_DOCUMENT: {
    INVOICE: "RECHNUNG",
    "CREDIT NOTE": "GUTSCHRIFT"
  }
};
